'use strict';

// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CALYPSO = exports.CALYPSO = '#00a4bd';
var CALYPSO_DARK = exports.CALYPSO_DARK = '#0091ae';
var CALYPSO_MEDIUM = exports.CALYPSO_MEDIUM = '#7fd1de';
var CALYPSO_LIGHT = exports.CALYPSO_LIGHT = '#e5f5f8';
var SORBET = exports.SORBET = '#ff8f59';
var SORBET_DARK = exports.SORBET_DARK = '#e68250';
var SORBET_MEDIUM = exports.SORBET_MEDIUM = '#ffc7ac';
var SORBET_LIGHT = exports.SORBET_LIGHT = '#fff3ee';
var LORAX = exports.LORAX = '#ff7a59';
var LORAX_DARK = exports.LORAX_DARK = '#e66e50';
var LORAX_MEDIUM = exports.LORAX_MEDIUM = '#ffbcac';
var LORAX_LIGHT = exports.LORAX_LIGHT = '#fff1ee';
var MARIGOLD = exports.MARIGOLD = '#f5c26b';
var MARIGOLD_DARK = exports.MARIGOLD_DARK = '#dbae60';
var MARIGOLD_MEDIUM = exports.MARIGOLD_MEDIUM = '#fae0b5';
var MARIGOLD_LIGHT = exports.MARIGOLD_LIGHT = '#fef8f0';
var CANDY_APPLE = exports.CANDY_APPLE = '#f2545b';
var CANDY_APPLE_DARK = exports.CANDY_APPLE_DARK = '#d94c53';
var CANDY_APPLE_MEDIUM = exports.CANDY_APPLE_MEDIUM = '#f8a9ad';
var CANDY_APPLE_LIGHT = exports.CANDY_APPLE_LIGHT = '#fdedee';
var NORMAN = exports.NORMAN = '#f2547d';
var NORMAN_DARK = exports.NORMAN_DARK = '#d94c71';
var NORMAN_MEDIUM = exports.NORMAN_MEDIUM = '#f9aabe';
var NORMAN_LIGHT = exports.NORMAN_LIGHT = '#fdedf2';
var THUNDERDOME = exports.THUNDERDOME = '#6a78d1';
var THUNDERDOME_DARK = exports.THUNDERDOME_DARK = '#5e6ab8';
var THUNDERDOME_MEDIUM = exports.THUNDERDOME_MEDIUM = '#b4bbe8';
var THUNDERDOME_LIGHT = exports.THUNDERDOME_LIGHT = '#f0f1fa';
var OZ = exports.OZ = '#00bda5';
var OZ_DARK = exports.OZ_DARK = '#00a38d';
var OZ_MEDIUM = exports.OZ_MEDIUM = '#7fded2';
var OZ_LIGHT = exports.OZ_LIGHT = '#e5f8f6';
var FLAT_EARTH = exports.FLAT_EARTH = '#253342';
var PANTERA = exports.PANTERA = '#2d3e50';
var OBSIDIAN = exports.OBSIDIAN = '#33475b';
var HEFFALUMP = exports.HEFFALUMP = '#425b76';
var SLINKY = exports.SLINKY = '#516f90';
var EERIE = exports.EERIE = '#7c98b6';
var FLINT = exports.FLINT = '#99acc2';
var BATTLESHIP = exports.BATTLESHIP = '#cbd6e2';
var GREAT_WHITE = exports.GREAT_WHITE = '#dfe3eb';
var KOALA = exports.KOALA = '#eaf0f6';
var CIRRUS = exports.CIRRUS = '#f2f5f8';
var GYPSUM = exports.GYPSUM = '#f5f8fa';
var OLAF = exports.OLAF = '#ffffff';
var MONOLITH = exports.MONOLITH = '#000000';
var CHART_RED = exports.CHART_RED = '#ea90b1';
var CHART_ORANGE = exports.CHART_ORANGE = '#fea58e';
var CHART_YELLOW = exports.CHART_YELLOW = '#f5c78e';
var CHART_GREEN = exports.CHART_GREEN = '#a2d28f';
var CHART_AQUA = exports.CHART_AQUA = '#51d3d9';
var CHART_BLUE = exports.CHART_BLUE = '#81c1fd';
var CHART_PURPLE = exports.CHART_PURPLE = '#bda9ea';
var CHART_DARK_PURPLE = exports.CHART_DARK_PURPLE = '#9784c2';
var LINK_HOVER = exports.LINK_HOVER = '#007a8c';
var BUTTON_PRIMARY_HOVER_FILL = exports.BUTTON_PRIMARY_HOVER_FILL = '#ff8f73';
var BUTTON_SECONDARY_TEXT = exports.BUTTON_SECONDARY_TEXT = '#ff7a53';
var BUTTON_SECONDARY_HOVER_FILL = exports.BUTTON_SECONDARY_HOVER_FILL = '#fff8f6';
var BUTTON_SECONDARY_ACTIVE_FILL = exports.BUTTON_SECONDARY_ACTIVE_FILL = '#ffebe6';
var BUTTON_TERTIARY_LIGHT_TEXT = exports.BUTTON_TERTIARY_LIGHT_TEXT = '#506e91';
var BUTTON_TERTIARY_LIGHT_HOVER_FILL = exports.BUTTON_TERTIARY_LIGHT_HOVER_FILL = '#e5eaf0';
var BUTTON_DANGER_HOVER_FILL = exports.BUTTON_DANGER_HOVER_FILL = '#ff5962';
var BUTTON_DISABLED_TEXT = exports.BUTTON_DISABLED_TEXT = '#b0c1d4';
var FOCUS_RING_BASE = exports.FOCUS_RING_BASE = '#00d0e4';
var ALERT_DANGER = exports.ALERT_DANGER = '#f04b51';
var ALERT_WARNING = exports.ALERT_WARNING = '#fdf3e1';
var ALERT_SUCCESS = exports.ALERT_SUCCESS = '#5967bc';
var LINKEDIN = exports.LINKEDIN = '#0077b5';
var TWITTER = exports.TWITTER = '#55acee';
var FACEBOOK = exports.FACEBOOK = '#3b5998';
var GOOGLE = exports.GOOGLE = '#dd4b39';
var XING = exports.XING = '#026466';
var PINTEREST = exports.PINTEREST = '#bd081c';
var RSS = exports.RSS = '#f26522';
var YOUTUBE = exports.YOUTUBE = '#ff0000';
var INSTAGRAM = exports.INSTAGRAM = '#c13584';
var TRANSPARENT_DARK = exports.TRANSPARENT_DARK = 'rgba(0, 0, 0, 0)';
var TRANSPARENT_LIGHT = exports.TRANSPARENT_LIGHT = 'rgba(255, 255, 255, 0)';
var TRANSPARENT = exports.TRANSPARENT = 'rgba(0, 0, 0, 0)';